import { useState } from "react";

export const useMask = () => {
  const [maskedValue, setMaskedValue] = useState("");

  const applyMask = (inputValue) => {
    const cleanedValue = inputValue.replace(/\D/g, "");
    const valueSplit = cleanedValue.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    const shouldFormat = !valueSplit[2];
    const formattedNumber = `(${valueSplit[1]})${" " + valueSplit[2]}${
      valueSplit[3] ? " - " + valueSplit[3] : ""
    }`;

    return shouldFormat ? valueSplit[1] : formattedNumber;
  };

  const handleChange = (e) => {
    const maskedValue = applyMask(e.target.value);
    setMaskedValue(maskedValue);
  };

  return { maskedValue, onChange: handleChange };
};
